"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _default = function _default(dataSelector, stageAction) {
  return function (Component) {
    var StageOnMountHOCWrapper =
    /*#__PURE__*/
    function (_PureComponent) {
      (0, _inherits2.default)(StageOnMountHOCWrapper, _PureComponent);

      function StageOnMountHOCWrapper() {
        (0, _classCallCheck2.default)(this, StageOnMountHOCWrapper);
        return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(StageOnMountHOCWrapper).apply(this, arguments));
      }

      (0, _createClass2.default)(StageOnMountHOCWrapper, [{
        key: "componentWillMount",
        value: function componentWillMount() {
          if (this.props.data) {
            this.props.stage(this.props.data);
          }
        }
      }, {
        key: "render",
        value: function render() {
          /*eslint no-unused-vars: ["error", { "ignoreRestSiblings": true }]*/

          /*eslint react/prop-types: [2, { "ignore": ["dispatch"]}]*/
          var _this$props = this.props,
              dispatch = _this$props.dispatch,
              data = _this$props.data,
              stage = _this$props.stage,
              rest = (0, _objectWithoutProperties2.default)(_this$props, ["dispatch", "data", "stage"]);
          return _react.default.createElement(Component, rest);
        }
      }]);
      return StageOnMountHOCWrapper;
    }(_react.PureComponent);

    StageOnMountHOCWrapper.propTypes = {
      data: _react.PropTypes.object,
      stage: _react.PropTypes.func.isRequired
    };

    var mapStateToProps = function mapStateToProps(state) {
      return {
        data: dataSelector(state)
      };
    };

    var name = Component.displayName || Component.name;
    StageOnMountHOCWrapper.displayName = "StageOnMount(" + name + ")";
    StageOnMountHOCWrapper.wrappedComponent = Component;
    return (0, _reactRedux.connect)(mapStateToProps, {
      stage: stageAction
    })(StageOnMountHOCWrapper);
  };
};

exports.default = _default;
module.exports = exports.default;